import { useOutletContext, useParams } from "react-router";
import type { JSX } from "react";

import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import { Lock } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import SpacePath from "components/SpacePath";
import { useLayoutActions } from "views/Account/Integrations/hooks/useLayoutActions";
import { useLayoutHeading } from "views/Account/Integrations/hooks/useLayoutHeading";
import { useLayoutMeta } from "views/Account/Integrations/hooks/useLayoutMeta";
import { IntegrationsOutletContext } from "views/Account/Integrations/types";

import { ExternalIntegrationQueryResponse } from "./types";

type PageLayoutProps = {
  children: React.ReactNode;
  actions?: JSX.Element | null;
  data?: ExternalIntegrationQueryResponse;
};

const PageLayout = ({ children, actions, data }: PageLayoutProps) => {
  const { integrationId } = useParams<{ integrationId: string }>();
  const { integration } = useOutletContext<IntegrationsOutletContext>();

  useBreadcrumbs([
    {
      title: "Integrations",
      link: "/integrations",
    },
    {
      title: integration.name,
      link: `/integrations/${integration.id}`,
    },
    {
      title: integrationId ?? "",
    },
  ]);

  useLayoutHeading(integrationId ?? "");
  useLayoutActions(actions);
  useLayoutMeta(
    <>
      <SpacePath
        variant="meta"
        spaceId={data?.externalIntegration.spaceDetails.id}
        fallbackName={data?.externalIntegration.spaceDetails.name}
      />
      <MetaInfoListItem icon={Lock} tooltip="Authentication type">
        Basic
      </MetaInfoListItem>
    </>
  );

  return <>{children}</>;
};

export default PageLayout;
